import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { IPhoneNumber } from 'src/app/core/interfaces/login/setphonenumber.interface';
import { LoginService } from 'src/app/core/services/login/login.service';
import { SetphonenumberService } from 'src/app/core/services/login/setphonenumber.service';
import { ServersideAlertService } from 'src/app/core/services/onboarding/serverside-alert.service';
import { destructSubscriptionArray } from 'src/app/core/ui-helpers/functions/destruct-subscription-array';

@Component({
  selector: 'app-set-phonenumber',
  templateUrl: './set-phonenumber.component.html',
  styleUrls: ['./set-phonenumber.component.scss'],
})
export class SetPhonenumberComponent implements OnInit, OnDestroy {
  // Button and textbox names
  headerText = 'Set Phone Number';
  phoneText = 'Phone Number';
  phonebtnTxt = 'Send Code';
  subheaderText =
    'Please provide your US mobile number to increase the security of your account by adding US mobile phone number where you can/will receive verification code.';
  form: FormGroup;
  subsciptions: Subscription[] = [];

  constructor(
    private fb: FormBuilder,
    private ssas: ServersideAlertService,
    private ls: LoginService,
    private router: Router,
    private sphs: SetphonenumberService
  ) {}

  ngOnInit(): void {
    this.form = this.fb.group({
      phoneNumber: ['', [Validators['required']]],
    });
  }

  ngOnDestroy(): void {
    destructSubscriptionArray(this.subsciptions);
  }

  async sendPhoneCode() {
    if (this.form.valid) {
      const payload: IPhoneNumber = {
        PhoneNumber: this.form.get('phoneNumber')?.value ?? '',
      };
      this.sphs.setPhoneNumber = payload.PhoneNumber;
      this.subsciptions.push(
        this.ls.sendUserPhoneCode(payload).subscribe((res: any) => {
          if (res.Success === true) {
            this.redirectPhoneCode();
          } else {
            this.ssas.reportAlert([res.Message], 'error');
          }
        })
      );
    } else {
      this.form.markAllAsTouched();
    }
  }

  redirectPhoneCode() {
    this.router.navigate(['/verifyphonecode']);
  }
}
